export default __webpack_public_path__ + "static/media/04.2d2fc716.jpg";